export const FETCH_MEAL_PULL_LIST = "FETCH_MEAL_PULL_LIST";
export const FETCH_MEAL_PULL_LIST_SUCCESS = "FETCH_MEAL_PULL_LIST_SUCCESS";
export const FETCH_MEAL_PULL_LIST_FAILURE = "FETCH_MEAL_PULL_LIST_FAILURE";

export const ACKNOWLEDGE_MEAL_PROFILE = "ACKNOWLEDGE_MEAL_PROFILE";

export const DOWNLOAD_MEAL_PULL_LIST_PDF = "DOWNLOAD_MEAL_PULL_LIST_PDF";
export const DOWNLOAD_MEAL_PULL_LIST_PDF_SUCCESS =
  "DOWNLOAD_MEAL_PULL_LIST_PDF_SUCCESS";
export const DOWNLOAD_MEAL_PULL_LIST_PDF_FAILURE =
  "DOWNLOAD_MEAL_PULL_LIST_PDF_FAILURE";
